import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IPlatformUserPasswordIm } from '../platform-user-password-im.model';
@Injectable({ providedIn: 'root' })
export class PlatformUserPasswordService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/PlatformUserPassword`;
  }
  post(platformUserPasswordIm: IPlatformUserPasswordIm): Observable<any> {
    const headers = this.createHeaders();
    return this.http.post<any>(this.baseUrl, platformUserPasswordIm, { headers });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
